import React, {Component} from "react";

// Using PROPS for label
const NavbarLabel = (props)=>{
  return (
    <div className="navbarChildLabel">{props.label}</div>
  );
};
class Navbar extends Component {
  render() {
    return (
      <div className="navbarPar">
      <div className="navbarChildText">
        Yvonne Armelia
      </div>
      
      <div className="navbarParForLabel">
        <NavbarLabel label="Home" />
        <NavbarLabel label="About" />
        <NavbarLabel label="Project" />
      </div>
    </div>
    );
  };
};

export default Navbar;